
import React from "react";
import { cn } from "@/lib/utils";

interface CustomCompassProps {
  className?: string;
  size?: number;
}

const CustomCompass = ({ className, size = 24 }: CustomCompassProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("text-current", className)}
    >
      {/* Outer circle - stroke only, no fill */}
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      
      {/* Compass needle - diamond/arrow shape pointing northeast */}
      <path
        d="M12 6L16 12L12 10L8 12L12 6Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CustomCompass;
